import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { api, formatApiError } from "@/lib/api";

export default function AdminCustomers() {
  const [customers, setCustomers] = useState([]);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get("/admin/customers");
        setCustomers(data);
      } catch (e) {
        toast.error(formatApiError(e.response?.data?.detail) || "Failed to load");
      }
    })();
  }, []);

  return (
    <div data-testid="admin-customers-page">
      <div className="mb-6">
        <div className="overline text-amber-400">Directory</div>
        <h1 className="font-serif-display text-3xl mt-2">Customers</h1>
      </div>

      <div className="bg-slate-800/60 border border-white/5 rounded-lg overflow-hidden">
        <Table>
          <TableHeader>
            <TableRow className="border-white/5 hover:bg-transparent">
              <TableHead className="text-slate-400">Name</TableHead>
              <TableHead className="text-slate-400">Email</TableHead>
              <TableHead className="text-slate-400">Phone</TableHead>
              <TableHead className="text-slate-400">Orders</TableHead>
              <TableHead className="text-slate-400">Total spent</TableHead>
              <TableHead className="text-slate-400">Last order</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {customers.length === 0 ? (
              <TableRow><TableCell colSpan={6} className="text-center text-slate-500 py-10"
                data-testid="customers-empty">No customers yet.</TableCell></TableRow>
            ) : customers.map((c, i) => (
              <TableRow key={c.id} className="border-white/5" data-testid={`customer-row-${i}`}>
                <TableCell>{c.name}</TableCell>
                <TableCell className="text-slate-400">{c.email}</TableCell>
                <TableCell className="text-slate-400">{c.phone}</TableCell>
                <TableCell className="font-mono-accent">{c.order_count || 0}</TableCell>
                <TableCell className="font-mono-accent">
                  ₹{Number(c.total_spent || 0).toLocaleString("en-IN")}
                </TableCell>
                <TableCell className="text-xs text-slate-500">
                  {c.last_order_at ? new Date(c.last_order_at).toLocaleDateString("en-IN") : "—"}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
    </div>
  );
}
